import { useEffect, useState } from 'react';

/**
 * Хук для определения, завершена ли гидратация компонента на клиенте.
 * Возвращает false при SSR и true после гидратации.
 *
 * @returns {Boolean} true если компонент гидратирован, false при SSR
 */
export const useIsHydrated = () => {
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    return isHydrated;
};
